<template>
  <div>
    <div class="page_container warehousingManagePage">
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>入库管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <!-- 主要内容 start -->
      <div class="main_container">
        <div class="operation_wrap flex-between">
          <div class="select_add flex-rowl">
            <p class="flex-rowl" @click="handleToast">
              <i class="iconfont icon-xinzeng"></i> 入库计划
            </p>
          </div>
          <div class="filter flex-rowr">
            <div class="search_wrap flex-between">
              <el-input
                v-model="searchTxt"
                placeholder="输入SKU编码/ISBN编码查找匹配商品"
                @keyup.enter.native="handleSearch"
              ></el-input>
              <div class="search_btn flex-rowc" @click="handleSearch">
                <i class="iconfont icon-chazhaotubiao"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          class="list_wrap"
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)"
        >
          <template v-if="dataItem.id">
            <div class="item_wrap">
              <div class="item_main_wrap flex-rowl">
                <div class="content_wrap flex-between">
                  <div class="pic_box">
                    <el-image :src="dataItem.img" fit="contain">
                      <div slot="error" class="image-slot flex-rowc">
                        <i class="iconfont icon-zanwutupian1"></i>
                      </div>
                    </el-image>
                  </div>
                  <div class="intro_box flex-rowl">
                    <div class="block">
                      <h1>商品名称：</h1>
                      <p>
                        <span>{{ dataItem.commodityname }}</span>
                      </p>
                      <p>
                        <span>{{ dataItem.commodityname_e }}</span>
                      </p>
                      <p>
                        <span>{{ dataItem.commodityname_y }}</span>
                      </p>
                      <p>
                        <span>{{ dataItem.commodityname_m }}</span>
                      </p>
                      <p>
                        <span>{{ dataItem.commodityname_t }}</span>
                      </p>
                    </div>
                    <div class="block">
                      <p>
                        商品ID：<span>{{ dataItem.id }}</span>
                      </p>
                      <p>
                        企业名称（ID）：<span>{{
                          dataItem.qyname
                            ? dataItem.qyname
                            : dataItem.qy_accountid
                        }}</span>
                      </p>
                      <p>
                        SKU采购编码：<span>{{ dataItem.sku }}</span>
                      </p>
                      <p>
                        品牌标签：<span>{{ dataItem.brandname }}</span>
                      </p>
                      <p>
                        ISBN编码：<span>{{ dataItem.ISBN }}</span>
                      </p>
                      <p>
                        是否精品推荐：<span>{{ dataItem.isintro }}</span>
                      </p>
                    </div>
                    <div class="block">
                      <p>
                        是否上架：<span>{{ dataItem.commoditystate }}</span>
                      </p>
                      <p>
                        销售状态：<span>{{ dataItem.salestate }}</span>
                      </p>
                      <p>
                        限购状态：<span v-if="dataItem.islimit">{{
                          dataItem.islimit == "不限购"
                            ? dataItem.islimit
                            : "每人限购/" + dataItem.limitnum + "件"
                        }}</span>
                      </p>
                      <p>
                        所属分类：<span v-if="dataItem.labelname"
                          >{{ dataItem.labelname }}、</span
                        >
                        <span v-if="dataItem.labelname2"
                          >{{ dataItem.labelname2 }}、</span
                        >
                        <span v-if="dataItem.labelname3">{{
                          dataItem.labelname3
                        }}</span>
                      </p>
                      <p>
                        商品类型：<span>{{ dataItem.comtype }}</span>
                      </p>
                    </div>
                    <div class="block">
                      <p>
                        结算类型：<span>{{ dataItem.paytype }}</span>
                      </p>
                      <p>
                        基础零售价：<span v-if="dataItem.price"
                          >¥ {{ dataItem.price }}</span
                        >
                      </p>
                      <p>
                        普通用户积分价：<span>{{ dataItem.userscore1 }}</span>
                      </p>
                      <p>
                        商务合作用户积分价：<span>{{
                          dataItem.userscore2
                        }}</span>
                      </p>
                      <p>
                        企业积分价：<span>{{ dataItem.userscore3 }}</span>
                      </p>
                      <p>
                        批发售价：
                        <span v-if="dataItem.groupprice"
                          >¥ {{ dataItem.groupprice }}</span
                        ><span>/每组</span>
                      </p>
                    </div>
                    <div class="block">
                      <!-- <p>
                      批发商品组规格： <span>{{ item.groupnum }}</span
                      ><span>件/每组</span>
                    </p> -->
                      <p>
                        单款混选起批数量： <span>{{ dataItem.startnum1 }}</span
                        ><span>件/起批</span>
                      </p>
                      <!-- <p>
                      混样多选起批数量： <span>{{ item.startnum2 }}</span
                      ><span>组</span>
                    </p> -->
                    </div>
                  </div>
                </div>
                <div class="edit_group flex-rowr">
                  <div class="editBtn" @click="handleGo">设置入库参数</div>
                </div>
              </div>
            </div>
          </template>
          <el-empty
            description="暂无数据"
            v-if="!loading && !dataItem.id"
          ></el-empty>
        </div>
      </div>
      <!-- 主要内容 end -->

      <div class="input_box scan" v-if="false">
        <!-- <input type="text" v-mtfocus placeholder="输入SKU编码/ISBN编码查找匹配商品" > -->
        <van-field
          v-model="searchTxt"
          ref="input"
          placeholder="输入SKU编码/ISBN编码查找匹配商品"
        />
      </div>
      <!-- <div class="primary-button" @click="handleSearch">查找</div>
      <div class="primary-button-plain" @click="handleToast">入库计划</div>
      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i>返回
      </div> -->
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { queryShop, getMenuAuthTwo, getMenuAuthThree } from "../../api/api";
export default {
  name: "wManageIndex",
  data() {
    return {
      menuItem: "", // 权限菜单
      roleId: "", // 用户角色ID
      operationAuth: "", // 操作权限
      buttonAuth: "", // 按钮权限

      loading: false,
      searchTxt: "",
      dataItem: "",
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.roleId = this.$store.state.USERINFO.qy.roleid;
    this.menuItem = this.$store.state.menuItem;
    this.getMenuAuthTwo();
  },
  methods: {
    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },
    // 获取按钮权限
    getMenuAuthThree() {
      let { menuItem } = this;
      getMenuAuthThree(menuItem.id).then((res) => {
        if (res.length == 0) return;
      });
    },

    handleToast() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$message.warning("暂无权限");
        return;
      }
      this.$message.warning("即将开放");
      return;
    },

    handleReturn() {
      this.$router.go(-1);
    },

    handleSearch() {
      if (this.searchTxt == "") {
        this.$$message.warning("请输入SKU编码/ISBN编码");
        return;
      } else {
        this.loading = true;
        queryShop({ keyword: this.searchTxt, openid: this.OPENID }).then((res) => {
          if (res.id) {
            this.loading = false;
            this.dataItem = res;
            // this.$store.commit("setShopItem", res);
            // this.$router.push(`/warehousIndex/wManageDetail/${this.searchTxt}`);
            // this.$router.push({path: '/detail', query: {searchTxt: this.searchTxt}})
          } else {
            this.loading = false;
            this.$message.warning("该商品暂不存在");
            return;
          }
        });
      }
    },

    handleGo() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$$message.warning("暂无权限");
        return;
      }
      this.$router.push(`/warehousIndex/wManageSettingList/${this.searchTxt}/${this.dataItem.id}`);
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingManagePage {
  // .input_box {
  //   margin-bottom: 117px;
  // }
  // .primary-button-plain {
  //   margin-top: 59px;
  // }
}
</style>